import { createPortal } from 'react-dom';

function ImageModal(props: { modalImage: { src: string; alt: string }; closeModal: () => void }) {
    return createPortal(
        <div className="image-modal-backdrop" onClick={props.closeModal}>
            <button onClick={props.closeModal} aria-label="Close">
                x
            </button>
            <img
                src={props.modalImage.src}
                alt={props.modalImage.alt}
                onClick={(e) => e.stopPropagation()}
            />
        </div>,
        document.body
    );
}

export {ImageModal};